import * as angular from "angular";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { User } from "../../models/user.model";
import { Team } from "../../models/team.model";
import { Assignment } from "../../models/assignment.model";
import { DialogUtils } from "../../helper/dialog.helper";

export let GroupAssignmentComponent = {
    selector: "vcGroupAssignment",
    templateUrl: "/angular/components/group/group-assignment.component.html",
    bindings: {
        listName: "=",
        assignment: "=",
        bulk: "=",
    },
    controller: class GroupAssignmentComponentController {
        // * bindings for typescript compiler *
        public listName: string;
        public assignment: Assignment;
        public bulk: boolean;
        // ************************************

        public teams: object[] = [];
        public users: object[] = [];
        public type: string = "team";
        public assignmentTime: number = 0;
        public noEndDate: boolean = false;
        public loading = false;
        public today: Date;
        public dateLocale: any = false;
        public assignmentError: string = "";
        private $cookies: any;

        private dialog: DialogUtils;
        private modelsUtils: any;

        private readonly $scope: any;

        constructor(
            $scope: any,
            $filter: any,
            $cookies: any,
            TeamDataProvider: TeamDataProvider,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            UserDataProvider: UserDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.$cookies = $cookies;
            TeamDataProvider.getAllTeams().then((teams: object[]) => {
                this.teams = teams;
            });
            UserDataProvider.getAllUsers().then((users: object[]) => {
                this.users = users;
            });
            this.today = new Date();
        }
        $onInit() {
            this.$scope.$watch(
                () => (this.assignment ? this.assignment.start : undefined),
                (newValue: any, oldValue: any) => {
                    if (oldValue != newValue && newValue && newValue.date) {
                        // Check if the date portion has changed and time is midnight
                        const firstPick = !oldValue || !oldValue.date;

                        if (firstPick) {
                            this.assignment.start.date.setHours(9, 0, 0, 0);
                        }
                        this.assignment.populateHours(this.assignment.start);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => (this.assignment ? this.assignment.end : undefined),
                (newValue: any, oldValue: any) => {
                    if (oldValue != newValue && newValue && newValue.date) {
                        // Check if the date portion has changed and time is midnight
                        const firstPick = !oldValue || !oldValue.date;
                        if (firstPick) {
                            this.assignment.end.date.setHours(17, 0, 0, 0);
                        }
                        this.assignment.populateHours(this.assignment.end);
                    }
                },
                true
            );

            this.noEndDate = this.assignment.id
                ? !this.assignment.end
                : this.$cookies.get("noEndDate") == 1;
        }

        removeUser(user: User, users: User[]): void {
            angular.forEach(users, (thisUser: User, $index: number) => {
                if (user.uid && user.uid == thisUser.uid) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninviteemail &&
                    user.campaigninviteemail == thisUser.campaigninviteemail
                ) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninvitephonenumber &&
                    user.campaigninvitephonenumber ==
                        thisUser.campaigninvitephonenumber &&
                    user.campaigninvitecountrycode ==
                        thisUser.campaigninvitecountrycode
                ) {
                    users.splice($index, 1);
                }
            });
        }

        removeTeam(team: Team, teams: Team[]): void {
            angular.forEach(teams, (thisTeam: Team, $index: number) => {
                if (team.tid && team.tid === thisTeam.tid) {
                    teams.splice($index, 1);
                }
            });
        }
        cancel(): void {
            this.dialog.cancel();
        }
        saveAssignment(): void {
            // Mark the field as touched to show validation
            if (
                this.assignment.users.length == 0 &&
                this.assignment.teams.length == 0
            ) {
                this.assignmentError =
                    "You must assign at least one user or team";
                return;
            }
            this.loading = true;
            if (this.noEndDate) {
                this.assignment.end = null;
                this.assignment.endtimestamp = null;
            }

            this.$cookies.put("noEndDate", this.noEndDate ? 1 : 0);
            this.dialog.hide(this.assignment);
        }
    },
};

angular
    .module("group")
    .component(GroupAssignmentComponent.selector, GroupAssignmentComponent);
